
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/article/[uid]",
      function () {
        return require("private-next-pages/magazine/article/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/article/[uid]"])
      });
    }
  